import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modal from 'angular-ui-bootstrap/src/modal';
import chargecodeReportComponent from './chargecode-report.component';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup'

let chargecodeReportModule = angular.module('chargecodereport', [
  uiRouter,
  modal,
  datepickerPopup
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('timebychargecode', {
    parent: 'app',
    url: '/admin/reports/timebychargecode',
    data: {
      pageHeader: true,
      pageTitle: 'Charge Code Report',
      pageDesc: '',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<chargecodereport></chargecodereport>'
  });

})

.component('chargecodereport', chargecodeReportComponent);

export default chargecodeReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/chargecode-report/chargecode-report.js